export default {
    spendingLimitsLabel: 'Beløpsgrenser',
    spendingLimitsRegionsLabel: 'Velg tillatte regioner',
    spendingLimitsNetLabel: 'Beløpsgrenser for netthandel',
    spendingLimitsInputDailyTitle: 'Beløpsgrense for daglig bruk',
    spendingLimitsInputMonthlyTitle: 'Beløpsgrense for bruk hver måned',
    spendingLimitsEcommerceInputDailyTitle: 'Beløpsgrense for daglig netthandelbruk',
    spendingLimitsEcommerceInputMonthlyTitle: 'Beløpsgrense for netthandelbruk hver måned',
    spendingLimitsPleaseSpeakWithProtector:
        'Hvis du vil endre på beløpsgrensene må du gi beskjed til foreldrene dine eller til foresatte',
    spendingLimitsNoLimit: 'Ingen grense satt',
    spendingLimitGenericError: 'Vi kunne dessverre ikke endre beløpsgrenser nå, vennligst prøv igjen senere.',
    spendingLimitsSuccess: 'Beløpsgrenser oppdatert',
    spendingLimitsInfoTitle: 'Informasjon om beløpsgrenser',
    spendingLimitsInfoContent: 'Her kan man sette grenser for bruk av kortet i butikk/minibank.',
    spendingLimitsInfoContentAdultCard: 'Her kan man se grenser for bruk av kortet i butikk/minibank.',
    spendingLimitsInfoAppTitle: 'Informasjon om beløpsgrenser for netthandel',
    spendingLimitsInfoAppContent: 'Her kan man sette grenser for bruk av kortet for netthandel.',
    spendingLimitsInfoAppContentAdultCard: 'Her kan man se grenser for bruk av kortet for netthandel.',
    spendingLimitsInfoEcommerceChild: 'For barnekort er ikke netthandel mulig, dette har aldersgrense 13 år.',
    regionBlockInfoTitle: 'Informasjon om regionsperre',
    regionBlockInfoContent: 'Regionsperre gjelder bruk av betalingskort i fysisk betalingsterminal.',
    spendingLimitsLabelDaily: 'Daglig',
    spendingLimitsLabelMonthly: 'Hver måned',
    spendingLimitsLabelAddLimit: 'Legg til grense',
    spendingLimitsLabelNoLimit: 'Ingen',
    spendingLimitsZero: '0 kr',
    spendingLimitsChildEcommerceWarning:
        'Bankkort Barn kan ikke brukes til netthandel. Ta kontakt med banken din for å få bestilt et Bankkort Ungdom.',
    spendingLimitsButtonTextAdult: 'Sett brukstillatelser',
    spendingLimitsButtonTextChild: 'Se brukstillatelser',
    spendingLimitLimitationChild: 'For barnekort gjelder følgende grenser:',
    spendingLimitLimitationTeenager: 'For ungdomskort gjelder følgende grenser:',
    spendingLimitLimitationGeneral: 'Produkt beløpgrenser:',
    spendingLimitLimitationDayDescription: 'Maksgrense for en dag:',
    spendingLimitLimitationMonthDescription: 'Maksgrense for 30 dager:',
    spendingLimitLimitationAppDayDescription: 'Nettbruk maksgrense for en dag:',
    spendingLimitLimitationAppMonthDescription: 'Nettbruk maksgrense for 30 dager:',
    spendingLimitLimitationChildOnline: 'Nettbruk ikke tillatt',
    spendingLimitAmountChildError: 'Barn har en maksgrense på',
    spendingLimitAmountTeenagerError: 'Ungdommer har en maksgrense på',
    spendingLimitMissingMonthError: 'Månedlig beløp må settes først',
    spendingLimitTypeChildError: 'Barn kan ikke bruke kortet til netthandel',
    spendingLimitsDiffDailyError: 'Daglig beløp må være mindre eller lik månedlig beløp',
    spendingLimitsDiffMonthlyError: 'Månedlig beløp må være større eller lik daglig beløp',
    spendingLimitsForbiddenError: 'Du har ikke lov til å endre denne beløpsgrensen',
    spendingLimitsMonthlyLimitExceededError:
        'Du har satt en høyere månedsgrense enn det som er tillatt. Se under for mer informasjon.',
    spendingLimitsDailyLimitExceededError:
        'Du har satt en høyere daglig grense enn det som er tillatt. Se under for mer informasjon.',
    spendingLimitsUnsupportedTypeError: 'Feil format på beløpsgrensen, vennligst bruk bare tall.',
    spendingLimitsDailyLimitNotSetError: 'Vennligst sett en daglig grense.',
    spendingLimitsMonthlyLimitNotSetError: 'Vennligst sett en månedsgrense.',
    spendingLimitFetchError: 'Vi kunne dessverre ikke hente beløpsgrenser nå, vennligst prøv igjen senere.',
    productSpendingLimitFetchError: 'Vi kunne dessverre ikke hente informasjon rundt maksgrenser på produkt.',
};
